import {
  LocationOfCourse,
  locationOfCourse,
} from '@les-sherpas/sherpas-toolbox';

export const getLocationOfInterest = ({
  queryParam,
}: {
  queryParam: string | string[] | undefined;
}) =>
  typeof queryParam === 'string' &&
  Object.keys(locationOfCourse).includes(queryParam)
    ? (queryParam as LocationOfCourse)
    : undefined;
